import useMyMutation from './useMyMutation'
import { API } from 'lib/api'
import { apiName } from 'config/api'

export const useLoginuserMutaion = () => {
    return useMyMutation({
        mutationFn : async (param) => {
            const ret = await API.post(apiName, '/items/postMediaUser', { body : param })
            return ret
        },
        queryKey : ['loginuser'],
    })
}